<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>รายละเอียดคำสั่งซื้อ</strong>
          <span class="float-right">
            <div v-if="canExchange && isExchangeable">
              <span
                class="order-btn-link"
                v-if="!isDisplayChange"
                @click="isDisplayChange = true"
                >เปลี่ยนสินค้า</span
              >
              <span
                class="mr-3 pointer"
                v-if="isDisplayChange"
                @click="cancel"
                >ยกเลิก</span
              >
              <span
                class="order-btn-link"
                v-if="isDisplayChange"
                @click="saveConfirmChangeProduct"
                >บันทึกและยืนยันคำสั่งซื้อ</span
              >
            </div>

            <!-- <span
              class="pr-2 order-btn-link"
              v-if="orderStatus == 16"
              @click="save"
              >บันทึก</span
            > -->
            <!-- <span
              class="order-btn-link"
              v-if="orderStatus == 13 || orderStatus == 16"
              @click="saveConfirm"
              >บันทึกและยืนยันคำสั่งซื้อ</span
            > -->
            <span
              class="pl-2 order-btn-link"
              v-if="orderStatus == 13"
              @click="returnProduct"
              >คืนสินค้า</span
            >
          </span>
        </p>
      </div>
    </div>
    <div class="bg-white">
      <b-container class="p-0">
        <b-table
          responsive
          :thead-tr-class="thTableProduct"
          :tbody-tr-class="trTableProduct"
          class="text-center"
          :fields="computedFields"
          :items="productDetailList"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:head(id)="">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              id="order-time-cb-all"
              name="orderTimeCbAll"
              @change="checkOrderHeader"
            ></b-form-checkbox>
          </template>
          <template v-slot:head(imageUrl)="">
            <div class="border-right">
              <strong>ภาพสินค้า</strong>
            </div> </template
          ><template v-slot:head(sku)="">
            <div class="border-right">
              <strong>SKU</strong>
            </div> </template
          ><template v-slot:head(productName)="">
            <div class="border-right">
              <strong>ชื่อสินค้า</strong>
            </div> </template
          ><template v-slot:head(productQty)="">
            <div class="border-right">
              <strong>จำนวนชิ้น</strong>
            </div> </template
          ><template v-slot:head(price)="">
            <div class="border-right">
              <strong>ราคาต่อหน่วย</strong>
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              :value="data.item.sku"
              v-model="productSelectList"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(imageUrl)="data">
            <div>
              <div
                v-if="data.item.imageUrl"
                class="table-image"
                v-bind:style="{
                  'background-image': 'url(' + data.item.imageUrl + ')',
                }"
              ></div>
              <div v-else>-</div>
            </div>
          </template>
          <template v-slot:cell(sku)="data">
            <div v-if="data.item.sku" class="text-table">
              <p class="m-0">{{ data.item.sku }}</p>
              <b-badge v-if="data.item.isReturned" pill variant="warning" class="px-3 py-2 mt-1 text-white">สินค้าถูกเปลี่ยน</b-badge>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(productName)="data">
            <div v-if="data.item.productName" class="text-left text-table">
              <p class="m-0">{{ data.item.productName }}</p>
              <span v-if="data.item.promotion">
                <b-badge pill variant="Info" class="px-3 py-2 GWP mt-1">{{
                  data.item.promotion
                }}</b-badge
                ><br />
              </span>
              <span class="text-danger" v-if="data.item.isFree == 1"
                >(ฟรี)</span
              >
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(productQty)="data">
            <div class="stock-text" v-if="data.item.productQty">
              <p class="m-0">{{ data.item.productQty | numeral("0,0") }}</p>
            </div>
            <div v-else class="stock-text"><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(price)="data">
            <p class="m-0 price-text" v-if="data.item.price">
              ฿ {{ data.item.price | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
          <template v-slot:cell(total)="data">
            <p
              class="m-0 price-text"
              v-if="data.item.price != 0 && data.item.productQty != 0"
            >
              ฿
              {{ (data.item.price * data.item.productQty) | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
          <template v-slot:cell(changeProduct)="data" v-if="isDisplayChange">
            <b-form-select
              @change="(val) => handleChangeProduct(val, data.index)"
              v-model="data.item.isChange"
              :options="options"
              :disabled="data.item.isReturned"
            ></b-form-select>
          </template>
          <template v-slot:cell(changeHistory)="data">
            <p
              class="order-btn-link"
              @click="changeHistoryProduct(data.item.sku)"
            >
              ประวัติการเปลี่ยน
            </p>
          </template>
        </b-table>

        <div class="py-3">
          <OrderDetailPanalAddProduct
            ref="orderDetailPanalAddProduct"
            v-if="canExchange && isExchangeable && isDisplayChange"
            :orderStatus="orderStatus"
            :orderProductDetail="changeProductList"
            :orderProductPriceDetail="orderProductPriceDetail"
            :productIdList="productIdList"
            :isExchangeable="isExchangeable"
            :orderId="orderId"
            :isDisplayChange="isDisplayChange"
          />
        </div>

        <div class="p-4">
          <b-row>
            <b-col sm="7" class="d-flex justify-content-end align-items-end">
              <div class="bg-gray summarize">
                <b-row class="pt-3 pl-3">
                  <b-col sm="8" class="pb-2"
                    ><b>ค่าใช้จ่ายหลังสรุปยอด</b></b-col
                  >
                  <b-col sm="8" class="text-gray pb-2 ml-2"
                    ><b>ค่าขนส่งที่เกิดขึ้นจริง</b></b-col
                  >
                  <b-col sm="3" class="text-right"
                    ><b
                      >฿
                      {{
                        orderProductPriceDetail.realShippingCost
                          | numeral("0,0.00")
                      }}
                    </b></b-col
                  >
                  <b-col sm="8" class="text-gray pb-2 ml-2"
                    ><b>ค่าธรรมเนียมแพลตฟอร์ม</b></b-col
                  >
                  <b-col sm="3" class="text-right"
                    ><b
                      >฿
                      {{
                        orderProductPriceDetail.platformGP | numeral("0,0.00")
                      }}</b
                    ></b-col
                  >
                  <b-col sm="8" class="text-gray pb-2 ml-2"
                    ><b>ค่าธรรมเนียมการชำระเงิน</b></b-col
                  >
                  <b-col sm="3" class="text-right"
                    ><b
                      >฿
                      {{
                        orderProductPriceDetail.paymentFee | numeral("0,0.00")
                      }}</b
                    ></b-col
                  >
                  <b-col sm="8" class="text-gray pb-2 ml-2"
                    ><b>ค่าบริการอื่นๆ</b></b-col
                  >
                  <b-col sm="3" class="text-right"
                    ><b
                      >฿
                      {{
                        orderProductPriceDetail.serviceCost | numeral("0,0.00")
                      }}</b
                    ></b-col
                  >
                </b-row>
              </div>
            </b-col>
            <b-col sm="5" class="d-flex justify-content-end">
              <div class="bg-gray">
                <b-row class="pt-2 pl-3 pr-3 pb-2">
                  <b-col>
                    <b>ราคาสินค้า</b>
                  </b-col>
                  <b-col class="d-flex justify-content-end">
                    <b
                      >฿
                      {{
                        orderProductPriceDetail.productPrice | numeral("0,0.00")
                      }}</b
                    >
                  </b-col>
                </b-row>
                <b-row class="pt-0 pl-3 pr-3 pb-2">
                  <b-col sm="6">
                    <b
                      >ค่าจัดส่ง
                      <b-button
                        v-if="collapseShipping"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseShipping = false"
                      >
                        <b-icon icon="chevron-down"></b-icon>
                      </b-button>
                      <b-button
                        v-if="!collapseShipping"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseShipping = true"
                      >
                        <b-icon icon="chevron-up"></b-icon>
                      </b-button>
                    </b>
                  </b-col>
                  <b-col sm="6" class="d-flex justify-content-end">
                    <b
                      >฿
                      {{
                        orderProductPriceDetail.shippingCostSum
                          | numeral("0,0.00")
                      }}
                    </b>
                  </b-col>
                  <b-col>
                    <b-collapse
                      v-model="collapseShipping"
                      class="collapse-shipping"
                    >
                      <b-row class="pl-3">
                        <b-col sm="6">
                          <b class="text-gray">ค่าจัดส่ง</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >฿
                            {{
                              orderProductPriceDetail.shippingCost
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="6">
                          <b class="text-gray">ค่าธรรมเนียม</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >฿
                            {{
                              orderProductPriceDetail.shippingFee
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
                <b-row class="pt-0 pl-3 pr-3 pb-2">
                  <b-col sm="6">
                    <b
                      >ส่วนลด
                      <b-button
                        v-if="collapseDiscount"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseDiscount = false"
                      >
                        <b-icon icon="chevron-down"></b-icon>
                      </b-button>
                      <b-button
                        v-if="!collapseDiscount"
                        variant="link"
                        size="sm"
                        class="btn-collapse mb-1"
                        @click="collapseDiscount = true"
                      >
                        <b-icon icon="chevron-up"></b-icon>
                      </b-button>
                    </b>
                  </b-col>
                  <b-col sm="6" class="d-flex justify-content-end text-purple">
                    <b
                      >- ฿
                      {{ orderProductPriceDetail.discount | numeral("0,0.00") }}
                    </b>
                  </b-col>
                  <b-col>
                    <b-collapse
                      v-model="collapseDiscount"
                      class="collapse-shipping"
                    >
                      <b-row class="pl-3">
                        <b-col sm="6">
                          <b class="text-gray">ส่วนลดจากร้านค้า</b>
                        </b-col>
                        <b-col sm="6" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.storeDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="7">
                          <b class="text-gray">ส่วนลดจากแพลตฟอร์ม</b>
                        </b-col>
                        <b-col sm="5" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.platformDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                        <b-col sm="7">
                          <b class="text-gray">ส่วนลดค่าจัดส่ง</b>
                        </b-col>
                        <b-col sm="5" class="d-flex justify-content-end">
                          <b class="text-gray"
                            >- ฿
                            {{
                              orderProductPriceDetail.shippingDiscount
                                | numeral("0,0.00")
                            }}</b
                          >
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </b-col>
                </b-row>
                <div class="bg-purple pt-3 pb-3 pl-3 pr-3">
                  <b-row>
                    <b-col>
                      <b>ยอดสุทธิ</b>
                    </b-col>
                    <b-col class="d-flex justify-content-end">
                      <b
                        >฿
                        {{
                          orderProductPriceDetail.totalPrice | numeral("0,0.00")
                        }}</b
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <!-- <ModalAlertConfirm
        :msg="titleModal"
        :text="detailModal"
        btnConfirm="ตกลง"
        btnCancel="ยกเลิก"
        ref="isModalAlertConfirm"
        @confirm="acceptAction"
      /> -->
      <ModalAlert ref="modalAlert" :text="msgAlert" />
      <ModalAlertError ref="modalAlertError" :text="msgError" />
    </div>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
import OrderDetailPanalAddProduct from "./OrderDetailPanalAddProduct.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
// import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";

export default {
  name: "OrderDetailPanel",
  components: {
    BIcon, 
    OrderDetailPanalAddProduct, 
    ModalAlertError, 
    ModalAlert 
  },
  props: {
    orderStatus: {
      type: [String, Number],
      isRequired: true,
    },
    orderProductDetail: {
      type: Array,
      isRequired: true,
    },
    orderProductPriceDetail: {
      type: Object,
      isRequired: true,
    },
    productIdList: {
      type: Array,
      isRequired: true,
    },
    isOrderMain: {
      type: Boolean,
      isRequired: false,
    },
    isExchangeable: {
      type: Boolean,
      isRequired: false,
    },
    orderId: {
      type: [String, Number],
      isRequired: true,
    },
  },
  computed: {
    canExchange(){
      return this.notInIdExchangeable.indexOf(this.orderStatus) == -1;
    },
    computedFields() {
      if (this.orderStatus == 13) return this.fields;
      else if (this.canExchange) {
        let fields = this.fields.filter((field) => !field.hold);
        return fields.concat({
          key: "changeProduct",
          label: ``,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "140px",
          },
          hold: true,
        });
      } else return this.fields.filter((field) => !field.hold);
    },
  },
  created: async function () {
    await this.orderProductDetail.forEach((element, i) => {
      this.productDetailList.push({ ...element, isChange: 0, index: i });
    });
    this.productDetailListInit = this.productDetailList;
  },
  data() {
    return {
      notInIdExchangeable: [6,7,12],
      productDetailList: [],
      productDetailListInit: [],
      changeProductList: [],
      fields: [
        {
          key: "id",
          label: ``,
          hold: true,
        },
        {
          key: "imageUrl",
          label: `ภาพสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
          hold: false,
        },
        {
          key: "sku",
          label: `SKU`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "20%",
          },
          hold: false,
        },
        {
          key: "productName",
          label: `ชื่อสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
          hold: false,
        },
        {
          key: "productQty",
          label: `จำนวนชิ้น`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "price",
          label: `ราคาต่อหน่วย`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "total",
          label: `ราคาสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15  %",
          },
          hold: false,
        },
        // {
        //   key: "changeProduct",
        //   label: ``,
        //   class: "text-nowrap",
        //   thStyle: {
        //     "padding-left": "0px !important",
        //     "padding-right": "0px !important",
        //     width: "140px",
        //   },
        //   hold: true,
        // },
        {
          key: "changeHistory",
          label: ``,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
          hold: true,
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      isBusy: false,
      collapseShipping: true,
      collapseDiscount: true,
      collapseService: true,
      productSelectList: [],
      titleModal: "",
      detailModal: "",
      listAllDataId: [],
      selected: null,
      options: [
        { value: 0, text: "สินค้าปกติ" },
        { value: 1, text: "สินค้าเปลี่ยน" },
      ],
      isDisplayChange: false,
      msgAlert: '',
      msgError: '',
    };
  },
  methods: {
    checkTextNull(text) {
      return text ? text : "-";
    },
    changeProductItem(id) {
      console.log(`id`, id);
    },
    changeHistoryProduct(id) {
      console.log(`id`, id);
    },
    checkOrderHeader(value) {
      if (value) {
        this.productSelectList = this.productIdList;
      } else {
        this.productSelectList = [];
      }
    },
    returnProduct() {
      this.$emit("returnProduct", {
        data: productSelectList,
        title: "ยืนยันการคืนสินค้า",
        detail: "ต้องการทำรายการคืนสินค้าหรือไม่",
      });
    },
    handleChangeProduct: async function (value, i) {
      let filtered = [];
      filtered = await this.productDetailList.filter((el) => {
        return el.isChange == 1;
      });

      this.changeProductList = filtered;
      this.$refs.orderDetailPanalAddProduct.setProductDetailList(
        this.changeProductList
      );
    },
    saveConfirmChangeProduct: async function () {
      let products = await this.$refs.orderDetailPanalAddProduct.getProductDetailList();
      if (products == false) return;

      this.$isLoading = true

      let body = {
        orderId: this.orderId,
        deleteOrderItemIds: [],
        addItems: [],
      };
      await this.changeProductList.forEach((element) => {
        body.deleteOrderItemIds.push(element.orderItemId);
      });
      await products.forEach((element) => {
        body.addItems.push({
          productId: element.id,
          productQty: 1,
          price: element.newPrice,
        });
      });
      await this.axios
        .post(`${this.$baseUrl}/order/OrderItem`, body)
        .then((data) => {
          if(data.result == 1) {
            this.msgAlert = data.message
            this.$refs.modalAlert.show();
            setTimeout(() => { this.$emit("handleReload"); }, 1000);
          } else {
            this.msgError = data.message
            this.$refs.modalAlertError.show();
          }
        });
      this.$isLoading = false
    },
    saveConfirm: async function () {
      // this.titleModal = "บันทึกรายการ"
      // this.detailModal = "ต้องการบันทึกรายการหรือไม่"
      // this.confirmAction();
    },
    save() {},
    cancel: async function () {
      this.$isLoading = true
      this.productDetailList = this.productDetailListInit
      await this.$refs.orderDetailPanalAddProduct.setProductDetailList( this.changeProductList );
      this.isDisplayChange = false;
      this.$isLoading = false
    }
    // confirmAction: function() {
    //   this.$refs.isModalAlertConfirm.show();
    // },
    // acceptAction() {
    //   this.$refs.isModalAlertConfirm.hide();
    // },
  },
};
</script>

<style lang="scss" scoped>
.header-purple {
  padding: 1rem 1.5rem;
  background: #e0e1f4;
}
.price-text {
  white-space: nowrap;
}
.text-table {
  color: #7e7e7e;
}
.bg-gray {
  color: #333333;
  background-color: #f1f1f1;
  width: 85%;
}
.bg-purple {
  color: #ffffff;
  background-color: #8a44c3;
}
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #c5c5c5;
}
.text-purple {
  color: #8a44c3;
}
.collapse-shipping {
  margin-top: -5px;
}
.summarize {
  margin-right: -80px;
  width: 60%;
}
.stock-text {
  min-width: 80px;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.order-btn-link {
  color: #8f20c6;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
}
</style>
